import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c28ec616&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28ec616",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c28ec616')) {
      api.createRecord('c28ec616', component.options)
    } else {
      api.reload('c28ec616', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c28ec616&scoped=true&", function () {
      api.rerender('c28ec616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8qFO9M8xZMEj8/JS/comp/SearchFilterTokens.vue"
export default component.exports